import React, { Children, ReactElement } from 'react';
import * as S from './style';

type TabProperties = {
  title: string;
  show?: boolean;
  children?: ReactElement | ReactElement[] | undefined;
};

export function Tab({ title, show = true, children }: TabProperties) {
  if (!show) {
    return null;
  }
  return <div aria-details={title}>{children}</div>;
}

function Tabs({
  children,
  activeIndex,
}: {
  activeIndex: number | null;
  children: ReactElement<TabProperties> | Array<ReactElement<TabProperties>>;
}) {
  const tabTitles = Children.map<
    { title: string; show?: boolean; index: number },
    ReactElement<TabProperties>
  >(children, (c, index) => ({
    title: c.props.title,
    show: c.props.show,
    index,
  }));

  const hasActiveIndex = activeIndex !== null && activeIndex >= 0;

  return (
    <div>
      <S.TabTitleContainer>
        {tabTitles
          .filter((item) => item.show)
          .map((titleItem, itemIndex) => (
            <S.TabTitle
              isActive={itemIndex === activeIndex}
              key={titleItem.title}
            >
              {titleItem.title}
            </S.TabTitle>
          ))}
      </S.TabTitleContainer>
      {hasActiveIndex ? Children.toArray(children)[activeIndex] : undefined}
    </div>
  );
}

export default Tabs;
